import axios, { AxiosResponse } from "axios";
import store from "@/store/index";

/** ファイル送信（取込）で応答を待つ上限。ユーザー635件の取込で約6秒（ローカル）なので、十分な余裕を見て2分 */
const POST_FILE_TIMEOUT_MS = 120000;

const api = {

  apiConfig: ():object => {
    const config = {
      headers:{
        "Content-Type": "application/json",
        "x-api-key": process.env.VUE_APP_API_KEY,
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": store.getLanguage(),
      },
    };

    // 何らかのトークンがあれば追加して返す
    // TODO 認証回りが直ったら環境変数から取らないようにする
    if(/*process.env?.VUE_APP_AUTH_KEY ??*/ store.getToken()) config.headers = Object.assign(config.headers, {"Authorization": /*process.env.VUE_APP_AUTH_KEY ??*/ store.getToken()});
    return config;
  },
  // ファイル送信用設定
  apiConfig4PostFile: ():object => {
    const config = {
      headers:{
        "Content-Type": "multipart/form-data",
        "x-api-key": process.env.VUE_APP_API_KEY,
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": store.getLanguage(),
      },
    };
    if(store.getToken()) config.headers = Object.assign(config.headers, {"Authorization": store.getToken()});
    return config;
  },

  post<T = any, R = AxiosResponse<T>>(
    url: string,
    data?: any,
  ): Promise<R> {
    return axios.post(process.env.VUE_APP_API_BASE_URL+url, data, this.apiConfig());
  },
  get<T = any, R = AxiosResponse<T>>(
    url: string,
  ): Promise<R> {
    return axios.get(process.env.VUE_APP_API_BASE_URL+url, this.apiConfig());
  },
  // ファイル送信
  // 取込の途中で通信が切れると、応答が来ないまま待ち続けて画面が止まり、メッセージも出なかった（JCIKAIHATSU-496 受入テスト IX-03・IU-22）。
  // 待つ時間に上限を設け、ブラウザが通信の切断を知らせたら（offline）すぐ打ち切る。
  // どちらも呼び出し側の catch（「通信が途中で切れたため…」などのメッセージ）に入る
  postFile<T = any, R = AxiosResponse<T>>(
    url: string,
    data?: any,
  ): Promise<R> {
    const controller = new AbortController();
    const abortOnOffline = () => controller.abort();
    window.addEventListener("offline", abortOnOffline);
    return axios.post<T, R>(process.env.VUE_APP_API_BASE_URL+url, data, {
      ...this.apiConfig4PostFile(),
      timeout: POST_FILE_TIMEOUT_MS,
      signal: controller.signal,
    }).finally(() => window.removeEventListener("offline", abortOnOffline));
  },

};
export default api;
